<template>
	<el-carousel :interval="5000" arrow="always">
		<el-carousel-item v-for="item in 4" :key="item">
		  <h3>{{ item }}</h3>
		</el-carousel-item>
	</el-carousel>
</template>

<script>
	export default {
		name:'v-indexSwiper'
	}
</script>

<style>
	.el-carousel{
		
	}
	.el-carousel__item {
	    color: #475669;
	    font-size: 18px;
	    opacity: 0.75;
	    line-height: 300px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
	  }
</style>



// WEBPACK FOOTER //
// src/components/common/index_swiper.vue